// extracted by mini-css-extract-plugin
var _1 = "CarouselSlider-module__animateUploadProgressBarWidth--idqdT";
var _2 = "CarouselSlider-module__animatedBackground--ZII3k";
var _3 = "CarouselSlider-module__buttonNext--Ozerf";
var _4 = "CarouselSlider-module__buttonPrevious--l6ztX";
var _5 = "CarouselSlider-module__container--EzBWa";
var _6 = "CarouselSlider-module__image--_aISX";
var _7 = "CarouselSlider-module__imageContainer--Dj7M3";
var _8 = "CarouselSlider-module__instantScrolling--dnxlf";
var _9 = "CarouselSlider-module__isUploading--GOpky";
var _a = "CarouselSlider-module__item--xOIj9";
var _b = "CarouselSlider-module__placeholder--pD_9u";
var _c = "CarouselSlider-module__scrollingContainer--ii9tg";
var _d = "CarouselSlider-module__shouldCover--s7TMV";
var _e = "CarouselSlider-module__shouldHide--JJ7Tm";
var _f = "CarouselSlider-module__slider--Ubo_7";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "buttonNext", _4 as "buttonPrevious", _5 as "container", _6 as "image", _7 as "imageContainer", _8 as "instantScrolling", _9 as "isUploading", _a as "item", _b as "placeholder", _c as "scrollingContainer", _d as "shouldCover", _e as "shouldHide", _f as "slider" }
